import React from 'react';
import PropTypes from 'prop-types';
import './PulsatingCircle.css';


const toPixels = value => typeof value === 'number' ? `${value}px` : value;
const toSeconds = value => typeof value === 'number' ? `${value}s` : value;
const toNegativeSize = value => typeof value === 'number' ? `${-value}px` : `-${value}`;

export default function PulsatingCircle({
    backgroundColor,
    pulseColor,
    size,
    pulseRadius,
    duration,
    shadow,
    className,
    ariaLabel,
    ...buttonProps
}) {
    const customProperties = {
        '--pulsating-circle-background': backgroundColor,
        '--pulsating-circle-pulse-color': pulseColor,
        '--pulsating-circle-size': toPixels(size),
        '--pulsating-circle-pulse-radius': toPixels(pulseRadius),
        '--pulsating-circle-pulse-offset': toNegativeSize(pulseRadius),
        '--pulsating-circle-duration': toSeconds(duration),
        '--pulsating-circle-shadow': shadow,
    };
    const buttonClassName = ['pulsating-circle', className].filter(Boolean).join(' ');

    return (
        <button
            {...buttonProps}
            type={buttonProps.type || 'button'}
            className={buttonClassName}
            style={customProperties}
            aria-label={ariaLabel}
        />
    );
}

PulsatingCircle.propTypes = {
    backgroundColor: PropTypes.string,
    pulseColor: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    pulseRadius: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    duration: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    shadow: PropTypes.string,
    className: PropTypes.string,
    ariaLabel: PropTypes.string,
};

PulsatingCircle.defaultProps = {
    backgroundColor: '#ffffff',
    pulseColor: '#01a4e9',
    size: 30,
    pulseRadius: 30,
    duration: 1.25,
    shadow: '0 0 8px rgba(0, 0, 0, 0.3)',
    className: '',
    ariaLabel: 'Pulsante',
};
